import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Title from "../title";
import Footer from "../footer";
import {Carousel} from "antd";
import PageTitle from "../theme/components/pagetitle";
import BlogSingle from "../theme/components/BlogDetails";
import {applyLang} from "../../../i18n";
import Loader from "../loader";
import logger from "../../../services/logger"

export default class ActuDetail extends Component{

    componentDidMount() {
        const context=this.props.context
        const {org,config,data}=context

        const actu=applyLang(data[0],context.lang)

        if(actu.link){
            window.location.href=actu.link
        }
    }

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const actu=data[0]

        const title=actu.title
        const description=actu.description

        var image=null
        if(actu.type==="IMAGE" && actu.images.length>0){
            image=actu.images[0]
        }

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description} image={image}/>
                    <Loader/>
                </div>
            )
        }


        if(actu.link){
            return null
        }


        return(
            <div>
                <Meta context={context} title={title} description={description} image={image}/>
                <Header context={context}/>
                <PageTitle context={context} title={title} description={description} broadcamp={[
                    {label:"Actualités",url:org.BASE_WEB_URL+"/actualites"},
                ]}/>
                <div style={{minHeight:"50vh"}}>
                    <BlogSingle context={context} data={actu} />
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}

/*

{actu.type=="IMAGE" && actu.images.length==1 &&(

                    )}

                    {actu.type=="IMAGE" && actu.images.length>1 &&(
                        <Carousel style={{maxWidth:context.isMobile?"100%":"60%",backgroundColor:"#000",marginBottom:30}}>
                            {actu.images.map(i=><img src={i}/>)}
                        </Carousel>
                    )}
 */
